let assessmentContainer = `
`.trim();
let assessmentFrame = `
  width: 100vw;
  height: 100vh;
  overflow: auto;
`.trim();
export default {
  assessmentContainer,
  assessmentFrame,
}



// WEBPACK FOOTER //
// ./src/components/bz/assess-container/styles.js